import React from 'react';
import ItemLastUpdated from '../ItemLastUpdated/ItemLastUpdated';
import ItemViews from '../ItemViews/ItemViews';
import ItemFavorites from '../ItemFavorites/ItemFavorites';
import { classes } from './ItemInfoMobileView.st.css';
import { st, classes as sharedClasses } from '../../../../../../Shared/SharedText.st.css';
import { Text, TextPriority } from 'wix-ui-tpa';
import useObservable from '../../../../../../../Shared/Hooks/useObservable.Hook';
import { getTableSettings } from '../../../../../../Services/TableSettings.service';
import { TableColumns } from '../../../../../../../Constants/TableHeader.Constants';
import { useAppContext } from '../../../../../../Shared/AppContext';

export const ItemInfoMobileView = ({ item }: any) => {
  const { compId } = useAppContext();
  const [error1, tableDisplaySettings]: any = useObservable(getTableSettings(compId));

  const getDisplaySettings = (tableColumn: string) => {
    return (
      tableDisplaySettings &&
      tableDisplaySettings.find((data: any) => data.id === tableColumn)
    );
  };

  const displaySettings = {
    displayLastUpdated:
      getDisplaySettings(TableColumns.LAST_UPDATED)?.value || false,
    displayViews:
      getDisplaySettings(TableColumns.VIEWS_COUNTER)?.value || false,
    displayFavorites:
      getDisplaySettings(TableColumns.FAVORITES)?.value || false,
  };
  return (
    <div className={classes.itemInfoMobileViewContainer}>
      <div className={classes.itemInfoMobileViewSubContainer}>
        {displaySettings.displayLastUpdated && <ItemLastUpdated item={item} />}
        {displaySettings.displayLastUpdated && displaySettings.displayViews && (
          <div className={classes.dotContainer}>
            <Text
              className={st(sharedClasses.textAndDividersColor, {
                isMobile: true,
              })}
              priority={TextPriority.secondary}
            >
              ·
            </Text>
          </div>
        )}
        <div>{displaySettings.displayViews && <ItemViews item={item} />}</div>
      </div>
      <div>
        {displaySettings.displayFavorites && <ItemFavorites item={item} />}
      </div>
    </div>
  );
};
